var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5_1591)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#34C759",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4165 16.5L33.4998 18.5833L31.4165 20.6667M27.6665 18.5833H32.9925",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6319 18.7602L23.2963 18.0052C23.0769 17.5116 22.9672 17.2647 22.8032 17.0758C22.5976 16.8391 22.3296 16.665 22.0297 16.5732C21.7905 16.5 21.5204 16.5 20.9802 16.5C20.1899 16.5 19.7948 16.5 19.4631 16.6519C19.0724 16.8309 18.7195 17.2194 18.5789 17.6255C18.4596 17.9702 18.4938 18.3245 18.5622 19.0331C19.2899 26.5752 23.4248 30.7101 30.9669 31.4378C31.6755 31.5062 32.0298 31.5404 32.3745 31.4211C32.7806 31.2805 33.1692 30.9276 33.3481 30.5369C33.5 30.2052 33.5 29.8101 33.5 29.0198C33.5 28.4796 33.5 28.2095 33.4268 27.9702C33.3351 27.6704 33.1609 27.4024 32.9242 27.1968C32.7352 27.0327 32.4884 26.9231 31.9948 26.7037L31.2398 26.3681C30.7052 26.1305 30.4379 26.0117 30.1663 25.9859C29.9063 25.9612 29.6443 25.9977 29.4009 26.0924C29.1467 26.1914 28.9219 26.3787 28.4725 26.7532C28.0251 27.126 27.8014 27.3124 27.5281 27.4122C27.2858 27.5007 26.9655 27.5336 26.7103 27.4959C26.4224 27.4535 26.2019 27.3358 25.7611 27.1001C24.3893 26.3671 23.6329 25.6107 22.8999 24.2389C22.6643 23.7981 22.5465 23.5776 22.5041 23.2898C22.4665 23.0345 22.4992 22.7142 22.5878 22.4719C22.6876 22.1986 22.874 21.9749 23.2468 21.5275C23.6214 21.0781 23.8086 20.8533 23.9076 20.5991C24.0024 20.3558 24.0388 20.0937 24.0141 19.8337C23.9883 19.5621 23.8695 19.2948 23.6319 18.7602Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5_1591",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6875 0 0 0 0 0.6875 0 0 0 0 0.6875 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_1591"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_1591",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.44a53d29650c20ac0d3dc3a0781c3dd5.svg";
export { ForwardRef as ReactComponent };